import styled from '@emotion/styled'
import { ssrWarning } from 'utils/emotion'

const withStyle = (Component) =>
  styled(Component)((props) => {
    const { vertical, children } = props
    const display = vertical ? 'block' : 'inline-block'
    const {
      theme: {
        radioButtonGroupHoverColor,
        radioButtonColor,
        radioButtonTextColor,
        radioButtonGroupDisabledBg,
        radioButtonDisabledBorder,
        radioButtonDisabledTextColor,
      },
    } = props
    return `
        && {
          ${!children && 'margin-right: 0;'}
          > .ant-radio-wrapper {
            display: ${display};
            span:nth-child(2) ${ssrWarning} {
              margin-bottom: -1px;
            }
          }
         .ant-radio-inner::after {
            top: 1px;
            left: 1px;
            width: 13px;
            height: 13px;
            background-color: ${radioButtonGroupHoverColor};
          }

          .ant-radio-checked .ant-radio-inner,
          .ant-radio-focused .ant-radio-inner, 
          .ant-radio-wrapper:hover .ant-radio,
          .ant-radio:hover .ant-radio-inner,
          .ant-radio-input:focus + .ant-radio-inner {
            border-color: ${radioButtonGroupHoverColor};
          }

          .ant-radio-inner {
            border-color: ${radioButtonColor};
          }

          .ant-radio + * {
            color: ${radioButtonTextColor};
          }
          .ant-radio-disabled .ant-radio-inner{
            background-color: ${radioButtonGroupDisabledBg};
            border-color: ${radioButtonDisabledBorder} !important;
        }
        .ant-radio-disabled + span {
          color: ${radioButtonDisabledTextColor};
        }

        .ant-radio-disabled .ant-radio-inner::after {
          background-color: ${radioButtonColor};
      }
        }
      `
  })

export default withStyle
